import { reportError } from "@/utils/reportError";
import { fetchIsAdmin } from '@/utils/admin';
import { supabase } from '@/utils/supabase';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Redirect } from 'expo-router';
import { useEffect, useState } from 'react';
import { ActivityIndicator, Image, StyleSheet, View } from 'react-native';
import { ONBOARDING_SEEN_KEY } from './onboarding';

export default function Index() {
  const [destination, setDestination] = useState<string | null>(null);

  useEffect(() => {
    checkSessionAndRanking();
  }, []);

  const checkSessionAndRanking = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();

      if (!session) {
        // First open → onboarding ; otherwise straight to login.
        const onboardingSeen = await AsyncStorage.getItem(ONBOARDING_SEEN_KEY);
        setDestination(onboardingSeen === 'true' ? '/login' : '/onboarding');
        return;
      }

      // Accès admin : on réaffiche l'écran d'onboarding à CHAQUE connexion
      // (prévisualisation QA). L'onboarding renverra ensuite vers l'app.
      if (await fetchIsAdmin(session.user.id)) {
        setDestination('/onboarding?loggedIn=1');
        return;
      }

      // User is authenticated - check if they need to set ranking preference
      const { data: profile, error } = await supabase
        .from('profiles')
        .select('display_main_ranking')
        .eq('id', session.user.id)
        .single();

      // If error, profile doesn't exist, or display_main_ranking is null/undefined
      // Show ranking consent screen
      if (error || !profile || profile.display_main_ranking === null || profile.display_main_ranking === undefined) {
        setDestination('/ranking-consent');
      } else {
        setDestination('/(tabs)');
      }
    } catch (error) {
      reportError(error);
      setDestination('/onboarding');
    }
  };

  // Écran de chargement pendant checkSessionAndRanking() : il reproduit le
  // splash natif (fond #D4874A + même logo à la même taille, cf. plugin
  // expo-splash-screen dans app.config.js, imageWidth: 160) pour une
  // transition invisible splash → chargement, sans rupture de couleur.
  if (destination === null) {
    return (
      <View style={styles.loading}>
        <Image
          source={require('../assets/images/splash.png')}
          style={styles.loadingLogo}
          resizeMode="contain"
          accessibilityRole="image"
          accessibilityLabel="REPAS"
        />
        <ActivityIndicator size="small" color="#FFFFFF" style={styles.loadingSpinner} />
      </View>
    );
  }

  // Redirect based on destination
  return <Redirect href={destination as any} />;
}

const styles = StyleSheet.create({
  loading: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    // Même couleur que le splash natif (app.config.js → expo-splash-screen).
    backgroundColor: '#D4874A',
  },
  loadingLogo: {
    // Même largeur que le splash natif (imageWidth: 160). Le logo occupe 60%
    // de la largeur du canvas 1024px (marges intégrées) → logo visible ≈
    // 96pt, taille de splash classique. 160pt = 480px @3x pour 613px de
    // logo source → sous-échantillonné, net. (À 320pt le logo visible
    // faisait ≈192pt et frôlait le 1:1 avec la source → « gros » et
    // légèrement pixelisé.)
    width: 160,
    height: 160,
  },
  loadingSpinner: {
    position: 'absolute',
    bottom: 96,
  },
});
